export const API = 'deviceid' as const;
export const OTP = 'otp' as const;
export const MULTI_FACTOR = 'sim-otp' as const;
export const KEY = 'psk' as const;
export const NONE = 'none' as const;
